import { styled } from "@mui/material/styles";

import { Layout } from "../components/layout/layout";
import { GlobalFirstSection, GlobalSpacing } from "../components/layout/styles";
import { Typography } from "@mui/material";
import { FirstButton } from "../components/buttons/buttons";
import { useCustomNavigate } from "../provider/navigate";

const PageNotFound = () => {
	const { customNavigate } = useCustomNavigate();

	return (
		<Layout>
			<GlobalSpacing>
				<PageNotFoundWrapper>
					<Typography variant="h1">Oops!</Typography>
					<Typography variant="h3">404 - Page Not Found</Typography>

					<FirstButton onClick={customNavigate('/')}>
						<Typography variant="body1">Go Home</Typography>
					</FirstButton>
				</PageNotFoundWrapper>
			</GlobalSpacing>
		</Layout>
	)
}

const PageNotFoundWrapper = styled(GlobalFirstSection)(({ theme }) => ({
	display: "flex",
	flexDirection: "column",
	justifyContent: "center",
	alignItems: "center",
	gap: theme.spacing(3),
	padding: theme.spacing(3, 0),

	h1: {
		fontSize: '10rem'
	},

	h3: {
		fontWeight: 600,
	},

	[theme.breakpoints.down('md')]: {
		gap: theme.spacing(2),

		h1: {
			fontSize: '6rem',
		}
	}
}))

export { PageNotFound }